// Expiry warning badges — amber ≤30 days, red ≤15 days / expired.
// Taxi certificates intentionally have NO expiry tracking.
const FIELDS = [
  ["Osobna", "id_card_expiry"],
  ["Vozačka", "drivers_license_expiry"],
  ["Prometna", "vehicle_reg_expiry"],
];

const daysLeft = (iso) => {
  if (!iso) return null;
  const d = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return null;
  return Math.ceil((d.getTime() - Date.now()) / 86400000);
};

export const ExpiryBadges = ({ rec }) => {
  const badges = FIELDS.map(([label, field]) => {
    const dl = daysLeft(rec?.[field]);
    if (dl === null || dl > 30) return null;
    const expired = dl < 0;
    const red = expired || dl <= 15;
    return (
      <span
        key={field}
        data-testid={`expiry-badge-${field}`}
        title={`${label}: ${rec[field]}`}
        className={`inline-flex items-center gap-1 text-[9px] uppercase tracking-[0.15em] px-2 py-0.5 rounded-full border font-semibold ${
          red ? "border-red-500/50 text-red-300 bg-red-500/10"
              : "border-amber-400/50 text-amber-300 bg-amber-400/10"
        }`}
      >
        {label}: {expired ? "ISTEKLO" : `još ${dl} d`}
      </span>
    );
  }).filter(Boolean);
  if (!badges.length) return null;
  return <div className="flex flex-wrap gap-1.5 mt-1.5" data-testid="expiry-badges">{badges}</div>;
};

export default ExpiryBadges;
